import React from 'react'
import PropTypes from 'prop-types'
import './RadioButton.scss';
import { FormControlLabel, Radio } from '@mui/material';
import Lang from '../../../language/services/Lang';

const RadioButton = props => {
    const {elementId, value, text, isSelected, params, onChange, disabled } = props;   
    const translatedText = Lang.getCurrentValue(text, params);
    const handleChange = (_) => {
        if (onChange) {
            onChange(value);
        }
    };
    return (
        <FormControlLabel id={elementId}
                        value={value} disabled={disabled} 
                        checked={isSelected}
                        control={<Radio disableRipple={true} 
                        onChange={handleChange} />} label={translatedText} />
    )
}

RadioButton.propTypes = {
    elementId: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default RadioButton